import React from "react";
import {useTranslation} from "react-i18next";
import CheckIcon from "@mui/icons-material/Check";
import {Grid, Stack, Typography} from "@mui/material";
import {Dialog} from "../base/Dialog";
import {Frame} from "../base/Frame";
import {SupportIcon} from "../icons/SupportIcon";

export interface Props {
    open: boolean;
    onClose: (isSuccessful: boolean) => void;
}

export const ContactSupportConfirmDialog: React.FC<Props> = ({open, onClose}) => {
    const {t} = useTranslation();

    return (
        <Dialog
            title={t("dialogs.contact_support_confirm.title")}
            titleIcon={
                <SupportIcon
                    sx={{
                        stroke: "#404DB8",
                        width: "1.125rem",
                        height: "1.125rem",
                    }}
                />
            }
            cancelTitle={t("dialogs.actions.close")}
            open={open}
            onClose={() => onClose(false)}
        >
            <Stack>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Frame>
                            <Typography
                                fontSize={16}
                                textTransform="uppercase"
                                sx={{marginBottom: "1rem", color: "#404DB8"}}
                            >
                                <Stack alignItems="center" direction="row" gap={1}>
                                    <CheckIcon />
                                    <Typography variant="body1">{t("dialogs.contact_support_confirm.sent")}</Typography>
                                </Stack>
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <strong>{t("dialogs.contact_support_confirm.subtitle")}</strong>
                                </Grid>
                            </Grid>
                        </Frame>
                    </Grid>
                </Grid>
            </Stack>
        </Dialog>
    );
};
